<template>
  <div>
    <SelectPayroll @get-selected-payroll="getSelectedPayroll"></SelectPayroll>
    <div v-if="clientReference">
      <SelectClientInvoices
        :clientReference="clientReference"
        @get-selected-invoice="getSelectedInvoice"
      ></SelectClientInvoices>
    </div>
  </div>
</template>
<script>
import staffJs from "@/plugins/staff";
import clientsJs from "@/plugins/clients";
import invoicesAndQuotesJs from "@/plugins/invoicesAndQuotes";
import SelectPayroll from "@/components/StaffAndHR/SelectPayroll.vue";
import SelectClientInvoices from "@/components/InvoicesAndQuotes/SelectClientInvoices.vue";

export default {
  props: { clientReference: { default: null } },
  components: { SelectPayroll, SelectClientInvoices },

  methods: {
    getSelectedPayroll(selectedPayroll) {
      this.$emit("get-selected-payroll", selectedPayroll);
    },
    getSelectedInvoice(selectedInvoice) {
      this.$emit("get-selected-invoice", selectedInvoice);
    },
  },
};
</script>
